export const TEAMS_HITS_PER_PAGE = 10
export const ENDPOINTS_HITS_PER_PAGE = 20
